import React, { PropsWithChildren, useState } from 'react'
import { AppConfig, ConfigPropsGeneric, ConfigContext, loadConfigGenericFromFile } from '@amzn/aapn-front-end-config-lib'

export const ConfigBuilder = <T extends AppConfig>(props: PropsWithChildren<ConfigPropsGeneric<T>>): JSX.Element => {
  const [config, setConfig] = useState<T>()

  if (!config) {
    // eslint-disable-next-line
    loadConfigGenericFromFile(eval(process.env.Config ?? ''), props.codec).then(config => setConfig(config))
    return <></>
  }

  return (
    <ConfigContext.Provider value={config}>
      <props.context.Provider value={config}>{props.children}</props.context.Provider>
    </ConfigContext.Provider>
  )
}
